import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { Spinner } from "../ui-kit";
import { Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Empty } from "./shared";

export default function TeamBrokers() {
  const [rows, setRows] = useState(null);
  useEffect(() => { client.get("/tm/brokers").then(({ data }) => setRows(data)).catch((e) => toast.error(apiErr(e))); }, []);
  const copy = (t) => { navigator.clipboard.writeText(t).then(() => toast.success("Link copied")).catch(() => toast.error("Copy failed")); };
  if (!rows) return <Spinner />;
  if (!rows.length) return <Empty testid="brokers-empty" text="Koi active broker nahi hai." />;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {rows.map((b) => {
        const link = b.referral_link || b.account_url;
        return (
          <div key={b.id} data-testid={`tm-broker-${b.id}`} className="surface surface-hover p-5 transition-colors duration-200">
            <div className="flex items-center gap-3 mb-3">
              {b.logo ? <img src={b.logo} alt={b.name} className="w-10 h-10 object-contain bg-white/5" /> : <div className="w-10 h-10 bg-gold text-black flex items-center justify-center font-head font-bold">{b.name[0]}</div>}
              <div>
                <div className="text-white font-head">{b.name}</div>
                <div className="text-xs text-slate-500">{b.platform} · {(b.products || []).join(", ")}</div>
              </div>
            </div>
            {b.regulation && <div className="text-xs text-slate-400 mb-3">{b.regulation}</div>}
            {b.referral_code && <div className="text-xs text-slate-500 mb-2">Code: <span className="font-mono text-gold">{b.referral_code}</span></div>}
            <div className="font-mono text-[11px] text-slate-400 break-all bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-2 py-1.5 mb-3">{link || "No link set"}</div>
            {link && (
              <div className="flex gap-2">
                <button data-testid={`copy-broker-${b.id}`} onClick={() => copy(link)} className="btn-gold flex-1 py-2 text-xs flex items-center justify-center gap-1.5"><Copy size={13} />Copy Link</button>
                <a data-testid={`open-broker-${b.id}`} href={link} target="_blank" rel="noreferrer" className="px-3 py-2 text-xs border border-[color:var(--border-strong)] text-slate-300 hover:text-white flex items-center gap-1.5"><ExternalLink size={13} />Open</a>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
